import Api from "./Api";

export default {
  getFilesGrid(payload) {
    return Api().get(`/files/${payload.companyId}`, {
      params: payload.payload,
    });
  },
  deleteFile(payload) {
    return Api().delete(`/file/${payload.companyId}/${payload.id}`);
  },
  moveFileAndFolder(payload) {
    return Api().put(`/file-move`, payload);
  },
  editFileName(payload) {
    return Api().put(`/file-rename`, payload);
  },
  // uploadFile(companyId, payload) {
  //   return Api({ hasFile: true }).post(`/s3-upload/${companyId}`, { payload });
  // },
};
